// extracted by mini-css-extract-plugin
export default {"checkbox":"field-search-for-mapping_checkbox__uQ8-A","shadow":"field-search-for-mapping_shadow__Bx4KZ"};